import { TApiSavedReport } from "@timenotes/shared/src/services/saved-reports/saved-reports-types"

export function getSavedReportPath(savedReport: TApiSavedReport) {
  return `/${savedReport.kind}s/saved/${savedReport.id}`
}